import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class PipelineOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            isEntityFlowOpen:false,
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        if(this.props.layer.layerLocation!=null){
            var Pos = new window.Geo3DPoint(this.props.layer.layerLocation.POS.x , this.props.layer.layerLocation.POS.y , this.props.layer.layerLocation.POS.z);
            var V = new window.Geo3DPoint(this.props.layer.layerLocation.V.x , this.props.layer.layerLocation.V.y , this.props.layer.layerLocation.V.z);
            var Up = new window.Geo3DPoint(this.props.layer.layerLocation.UP.x , this.props.layer.layerLocation.UP.y , this.props.layer.layerLocation.UP.z);
            var Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
        }
        else{
            var PipelineLayer = this.props.layer.layerHandel;
            PipelineLayer.goto();
        }
        
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    EntityFlowtoggleOpen(){
        var PipelineLayer = this.props.layer.layerHandel;
        if(!this.state.isEntityFlowOpen){
            PipelineLayer.setDrawAllFlow(true);
            PipelineLayer.setFlowUseTexture(false);
            PipelineLayer.setFlowTextureMaxDensity(null, 1);
            PipelineLayer.setFlowColorWeight(0.5,0.5,0.5);
        }
        else{
            PipelineLayer.setDrawAllFlow(false);
        }
        this.setState({isEntityFlowOpen:!this.state.isEntityFlowOpen});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        const SettingType = (Layer.layerClass === "Pipeline")?"large setting icon":"large disabled setting icon";
        if(this.state.helpMode === "PipelineHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/-sE4f2_94Nc" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large database icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                {
                                    Layer.layerClass === "Pipeline"?
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("PipelineHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button> : null
                                }
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className={SettingType}></i>
                    </div>
                </div>
                {
                    (this.state.isSettingOpen&&Layer.layerClass === "Pipeline")?
                    <div className="ts very narrow container segment" >                        
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">管線流向：</h6>
                            </div>
                            <div className="ts six wide column">
                                <div class="ts toggle checkbox">
                                    <input type="checkbox" id={Layer.layerName + "EntityFlowtoggle"} checked={this.state.isEDLOpen} onClick={(e)=>this.EntityFlowtoggleOpen()}></input>
                                    <label for={Layer.layerName + "EntityFlowtoggle"}></label>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
                
            </div>
        );
    }
}

class PipelineLayre extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            PipelineLayre:{}
        };   
        this.pipelineLayreChecked = this.pipelineLayreChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.PipelineLayre);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,PipelineLayre:{}});
            }            
        }
    }
    pipelineLayreChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.addPipelineLayer({
                url: window.TERRAIN_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: function (e,PipelineLayre) {
                    if(e){
                        if(layer.LOCATION!=null){
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x , layer.LOCATION.POS.y , layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x , layer.LOCATION.V.y , layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x , layer.LOCATION.UP.y , layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos,V,Up);
                            window.main.OView.gotoCamera(Camera, true);
                        }
                        else{
                            var PipelineLayer = this.props.layer.layerHandel;
                            PipelineLayer.goto();
                        }
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        window.alertify.success("請調整地形透視已達到更好的效果");
                        layerThis.props.setOpenLayer(layer,PipelineLayre);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,PipelineLayre:PipelineLayre});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });                          
        }
        else{
            window.main.OView.removeLayer(this.state.PipelineLayre);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked; 
            layerThis.setState({isChecked:isChecked,PipelineLayre:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="PipelineLayre" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.pipelineLayreChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {PipelineLayre,PipelineOption};